import {createBrowserRouter, RouterProvider,} from "react-router-dom";
import ErrorPage from './ErrorPage';
import LoginPage from '../view/security/LoginPage/LoginPage';
import DeleteAccount from "../view/security/DeleteAccountPage/DeleteAccount";
import HomePage from "../view/HomePage/HomePage";
import {CheckLoginProxy} from "./CheckLoginProxy";
import {SettingsPage} from "../view/security/SettingsPage/SettingsPage";

export const Routes = () => {

    const routes = [
        {
            path: '/',
            element: <CheckLoginProxy><HomePage/></CheckLoginProxy>,
        },
        {
            path: '/login',
            element: <LoginPage/>,
        },
        {
            path: '/home',
            element: <CheckLoginProxy><HomePage/></CheckLoginProxy>,
        },
        {
            path: '/delete-account',
            element: <CheckLoginProxy><DeleteAccount/></CheckLoginProxy>,
        }, {
            path: '/settings',
            element: <CheckLoginProxy><SettingsPage/></CheckLoginProxy>,
        },


    ]
    routes.forEach(route => {
        route.errorElement = <ErrorPage/>
    })

    const router = createBrowserRouter(
        routes,
        { basename: '/app' }
    );

    return <RouterProvider router={router}/>;
}

